var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"landing-wrap"},[_c('div',{ref:"host",staticClass:"landing-host"}),(_vm.error)?_c('p',{staticClass:"landing-error"},[_vm._v(" No pudimos cargar la portada. "),_c('a',{attrs:{"href":"/utopie/"}},[_vm._v("Vuelve a intentarlo")]),_vm._v(". ")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }